import { useMutation } from "@tanstack/react-query";
import { CreateChallengeInvitationDto } from "@nestcoinco/hyper-api-gateway-api-client";

import { handleCreateChallengeInvitation } from "../../api-clients/challengeInvitationsClient";

function useCreateChallengeInvitationMutation() {
  const mutation = useMutation({
    mutationFn: (params: CreateChallengeInvitationDto) =>
      handleCreateChallengeInvitation(params),
  });

  return mutation;
}

export default useCreateChallengeInvitationMutation;
